<template lang="pug">
  <div>
    <nuxt keep-alive />
  </div>
</template>

<script>

export default {
  name: 'home',
  data () {
    return {
    }
  },
  components: {
  },
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>

<style lang="sass">
</style>
